import React, { useState, useEffect } from 'react'
import { object, shape, string } from 'prop-types'
import styles from './VideoPlayer.module.scss'
import Container from '@/component/Primitive/Container'
import Stack from '@/component/Primitive/Stack'
import Type from '@/component/Primitive/Type'
import SmartLink from '@/component/Primitive/SmartLink'
import Icon from '@/component/Primitive/Icon'
import { Description, Image } from './components'
import YouTubeEmbed from '@/component/Primitive/YouTubeEmbed'
import cx from 'classnames'

const OnDemandComponent = ({
  eventName,
  name,
  youtubeId,
  description,
  eventFullUrlPath,
  descriptionDetails,
  image = {}
}) => {
  const { mobile: mobileImage, desktop: desktopImage } = image

  const [hideCover, setHideCover] = useState(true)
  const [player, setPlayer] = useState(null)

  useEffect(() => {
    if (!player) {
      if (youtubeId && window.YT) {
        setPlayer(
          new window.YT.Player('youtubeVideo', {
            videoId: youtubeId
          })
        )
      }
    }
  }, [player, youtubeId, hideCover])

  const handleStartVideo = () => {
    setHideCover(true)
  }

  return (
    <>
      <div className={cx(styles.Cover, hideCover && styles.hide)}>
        <>
          <Image device="tablet" image={desktopImage} />
          <Image device="mobile" image={mobileImage} />
        </>

        <Container center gutter flex size="wide" className={styles.CoverInner}>
          <div className={styles.PlayButton}>
            <button
              onClick={() => handleStartVideo()}
              className={styles.PlayButtonInner}
            >
              <Icon
                type="play-square"
                width={60}
                height={60}
                className={cx(styles.PlayButtonIcon)}
              />
              <Stack gap="tiny" className={styles.PlayButtonText}>
                <Type as="h1" size={['heading8', 'heading4']} weight="medium">
                  {name}
                </Type>
                <Type as="h2" size={['body4', 'body3']} weight="medium">
                  {eventName}
                </Type>
              </Stack>
            </button>
          </div>
        </Container>
      </div>
      <div className={cx(styles.VideoPlayer, !hideCover && styles.hide)}>
        <Container
          center
          gutter
          flex
          size="mediumLarge"
          className={styles.VideoPlayerInner}
        >
          <Stack gap="small" className={styles.VideoPlayerStack}>
            <div className={styles.VideoEmbed}>
              <YouTubeEmbed videoId={youtubeId} />
            </div>
            <div className={styles.Title}>
              <Type
                as="h1"
                size={['heading8', 'heading6']}
                weight="medium"
                className={styles.Name}
              >
                {name}
              </Type>
            </div>
            <div className={styles.Subtitle}>
              <SmartLink
                to="/events[slug][oslug]"
                as={`/${eventFullUrlPath}`}
                className={styles.EventName}
              >
                <Type as="h2" size={['body4', 'body3']} weight="medium">
                  {eventName}
                </Type>
              </SmartLink>
            </div>

            <Description
              descriptionDetails={descriptionDetails}
              description={description}
            />
          </Stack>
        </Container>
      </div>
    </>
  )
}

OnDemandComponent.propTypes = {
  eventName: string,
  eventFullUrlPath: string,
  name: string,
  description: string,
  youtubeId: string,
  descriptionDetails: string,
  image: shape({
    mobile: object,
    desktop: object
  })
}

export default OnDemandComponent
